/**
 * Generates a safe, ID-compatible slug from a menu item href.
 * Internal paths like /autohaus-rauch become "autohaus-rauch".
 * External URLs like https://www.auto-schuetz.de become "auto-schuetz-de".
 */
export function getSafeSubmenuId(href: string): string {
  if (href.startsWith("/")) {
    return href.replace(/^\/+/, "").replace(/\//g, "-") || "root";
  }
  try {
    const url = new URL(href);
    const host = url.hostname.replace(/^www\./, "");
    return (
      host
        .replace(/[^a-zA-Z0-9-]/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "") || "external"
    );
  } catch {
    // Preserve stable IDs even if href is malformed and URL parsing fails.
    return (
      href
        .replace(/[^a-zA-Z0-9-]/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "") || "external"
    );
  }
}
